import { getAsJson } from "./AbstractService";
import { ConstantesApi } from "@common/utils";

export const getStoreIncidents = async ({ currentStore, productAccess }) => {
    const storeIds = currentStore.competitors?.map((competitor) => competitor.id) || [];
    storeIds.unshift(currentStore.id);
    const page = 0;
    const size = storeIds.length;
    const params = {
        api: ConstantesApi.API_STORE_INCIDENTS,
        data: {
            page,
            size,
            productAccessId: productAccess.id,
            countryCode: currentStore.country,
            storeIds,
        },
        skipDispatch: true
    };
    
    try {
        const response = await getAsJson(params);
        return response.content || [] ;
    } catch (error) {
        console.error('Error loading incidents:', error);
        return [];
    }
};
